import { branch, compose, renderNothing } from 'recompose';

import TaskItem from './taskItem';

const enhance = compose(
  branch(({ task }) => !task.title, renderNothing),
);

export default enhance(TaskItem);
